import cn from 'classnames';

import * as Grid from '@sravni/react-design-system/lib/Grid';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Heading } from '@sravni/react-design-system/lib/Typography';
import { useIsMobile } from '@sravni/react-utils';

import { Image } from '@/components/Image';

import { AdvantageCardMobile, AdvantagesCard } from './AdvantagesCard';
import integrationImg from './imgs/integration.png';
import styles from './styles.module.scss';
import { getAadvantages, getAadvantagesById } from './utils';

export const AdvantagesBlock = () => {
  const isMobile = useIsMobile();

  return (
    <Space direction="vertical" id="advantages" className={isMobile ? 'h-pt-16 h-pb-16' : 'h-pt-32 h-pb-32'}>
      <Heading level={2} className={cn(styles.title, 'h-text-center')}>
        Преимущества
      </Heading>
      <Space direction="vertical" size={16}>
        {isMobile ? (
          <Space direction="vertical" size={16}>
            {getAadvantages(true).map(({ icon, title, desc }) => (
              <AdvantageCardMobile key={title} title={title} icon={icon} desc={desc} />
            ))}
          </Space>
        ) : (
          <div className={styles.cards}>
            <Grid.Row gutter={16} className={styles.row}>
              <Grid.Col className={styles.col} span={isMobile ? 12 : 6}>
                <AdvantagesCard {...getAadvantagesById('rate', isMobile)} className={styles['card-big']} />
              </Grid.Col>
              <Grid.Col className={styles.col} span={isMobile ? 12 : 6}>
                <AdvantagesCard {...getAadvantagesById('payment', isMobile)} className={styles['card-big']} />
              </Grid.Col>
            </Grid.Row>
            <Grid.Row gutter={16} className={styles.row}>
              <Grid.Col className={styles.col} span={isMobile ? 12 : 4}>
                <AdvantagesCard
                  {...getAadvantagesById('tools', isMobile)}
                  className={styles['card-medium']}
                  titleLevel={4}
                />
              </Grid.Col>
              <Grid.Col className={styles.col} span={isMobile ? 12 : 4}>
                <AdvantagesCard
                  {...getAadvantagesById('stats', isMobile)}
                  className={styles['card-medium']}
                  titleLevel={4}
                />
              </Grid.Col>
              <Grid.Col className={styles.col} span={isMobile ? 12 : 4}>
                <AdvantagesCard
                  {...getAadvantagesById('manager', isMobile)}
                  className={styles['card-medium']}
                  titleLevel={4}
                />
              </Grid.Col>
            </Grid.Row>
          </div>
        )}
        <Grid.Row className={styles.row}>
          <Grid.Col className={styles.col} span={12}>
            <AdvantagesCard
              title={
                <Heading level={3} className={styles['black-card-text']}>
                  Прямая <span className={styles['green-text']}>интеграция с крупными игроками</span> финансовой и
                  страховой отрасли
                </Heading>
              }
              img={<Image className={styles['integration-img']} alt="advantages-card-img" src={integrationImg} />}
              variant="secondary"
              className={cn(styles['card-small'], styles['integration-card'])}
              direction="horizontal"
            />
          </Grid.Col>
        </Grid.Row>
      </Space>
    </Space>
  );
};
